import { render, staticRenderFns } from "./UvForm.vue?vue&type=template&id=31bb7c40&scoped=true"
import script from "./UvForm.vue?vue&type=script&lang=js"
export * from "./UvForm.vue?vue&type=script&lang=js"
import style0 from "./UvForm.vue?vue&type=style&index=0&id=31bb7c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb7c40",
  null
  
)

export default component.exports